import DevConfiguration from "Config/dev-config.json";
import ProdConfiguration from "Config/prod-config.json";
import Constants from "Constants/Constants";
import { IEnvConfigUtils } from "Interfaces/Utils/IEnvConfigUtils";
import { injectable } from "inversify";
import { EnvVariable } from "Models/EnvVariable";

@injectable()
export class EnvConfigUtils implements IEnvConfigUtils {
    public getEnvVariables(): EnvVariable {
        if (process.env.NODE_ENV === Constants.PRODUCTION) {
            return ProdConfiguration;
        }
        else {
            return DevConfiguration;
        }
    }
}


// WEBPACK FOOTER //
// ./src/Utils/EnvConfigUtils.tsx